<template>
  <div >
    <div class="panal mt-20">
      <div class="panal-header">All Event</div>
      <div class="panal-body">
        <table class="table table-hover table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col">Event Name</th>
              <th scope="col">Event Location</th>
              <th scope="col">EventDate</th>
              <th scope="col">EventStatus</th>
        
            </tr>
          </thead>
          <tbody>
            <!-- <tr>
              <td colspan="7">No Data</td>
            </tr> -->
            <tr v-if="empty"><td colspan="7" class="text-danger font-weight-bold"> No Data </td></tr>

            <tr v-else v-for="(item, index) in AllEvents" v-bind:key="index">
              <td>{{item.NameEN}} </td>
              <!-- <td> item. Event Location</td> -->
              <td>{{item.Address}} </td> 
              <td>{{item.StartDate}} </td> 
              <td v-if="item.EventStatus == 'Active'" class="text-primary"> 
                {{item.EventStatus}} 
              </td>
              <td v-else class="text-danger"> 
                {{item.EventStatus}} 
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import studentData from '../../services/student/studentDataServices';
import AllEventsService from '../../services/Event/event.services'

export default {
  
  name: "AllEvent",
  data() {
    return {
      message:'',
      isLoading : true, 
      empty:false,
      AllEvents: []
    };
  },
   mounted(){
       AllEventsService.SelectMarketing_AllEvents().then(Response =>{
             //  this.isLoading = false ;
               this.AllEvents = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
              //  console.log('All Events => ',this.AllEvents)
           }, error => {
              this.empty = true
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

        
      //this.currenUser.StudentID
            studentData.MarketingEvent_GetAllEvent().then(Response =>{
              // this.isLoading = false ;
               this.AccountDetails = Response.data
                // eslint-disable-next-line no-console
                  console.log(Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })
  }
  
};
</script>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #50bd77;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}
.table .thead-light th {
  font-size: 14px !important;
  background-color: #eaeaea !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
</style>